class BookmarkGroupsModel {
    groups: Array<VoyoBookmarkGroup>;

    constructor(data: any) {
        this.groups = data?.groups?.map((groupData: any) => new VoyoBookmarkGroup(groupData));
    }

    groupItems(groupId: string) {
        const group = this.groups.find(g => g.id === groupId);
        return group ? group.items : [];
    }

    remove(groupId: string, voyokey: string): void {
        const group = this.groups.find(g => g.id === groupId);
        if (!group) {
            return;
        }
        group.items = group.items.filter(b => b.voyokey !== voyokey);
    }

    add(groupId: string, voyokey: string, percent = 0, duration = 0): void {
        const group = this.groups.find(g => g.id === groupId);
        if (!group) {
            return;
        }

        group.append(new Bookmark({voyokey, data: {percent, duration}}));
    }
}

class VoyoBookmarkGroup {
    id: string;
    items: Array<Bookmark>;

    constructor(data: any) {
        this.id = data['id'];
        this.items = data['items'].map((b:any) => new Bookmark(b));
    }

    append(bookmark: Bookmark): void {
        const i = this.items.findIndex(b => b.voyokey === bookmark.voyokey);

        i === -1 ?
            this.items.push(bookmark) : this.items[i] = bookmark;
    }
}

class Bookmark {
    voyokey: string;
    percent: number;
    duration: number;

    constructor(data: any) {
        this.voyokey = data?.voyokey || null;
        this.percent = data?.data?.percent || data?.percent || 0;
        this.duration = data?.data?.duration || data?.duration || 0;
    }

    get percent10(): number {
        return Math.ceil(this.percent / 10) * 10;
    }
}

export default BookmarkGroupsModel;